webpackJsonp([2,1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(10);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function(cb) {
		__webpack_require__.e/* nsure */(0, function(require) {
			cb(__webpack_require__(2));
		});
	}

/***/ },
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Group = __webpack_require__(11);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var attachFastClick = __webpack_require__(7);
	attachFastClick.attach(document.body);
	
	var prefix = 'data:audio/mpeg;base64,';
	
	var load = __webpack_require__(1);
	var groupKeys = 12;
	var base = 0;
	exports.default = {
	    components: {
	        Group: _Group2.default
	    },
	    data: function data() {
	        return {
	            full: false,
	            loading: false
	        };
	    },
	
	    methods: {
	        play: function play(keyCode) {
	            load(function (module) {
	                var notes = module.notes;
	                var keys = [90, 88, 67, 86, 66, 78, 77, 65, 83, 68, 70, 71, 72, 74, 81, 87, 69, 82, 84, 89, 85];
	                if (keys.indexOf(keyCode) < 0) {
	                    return;
	                }
	                var whites = [0, 2, 4, 5, 7, 9, 11];
	                var index = base + 2 * groupKeys + whites[keys.indexOf(keyCode) % 7] + parseInt(keys.indexOf(keyCode) / 7) * groupKeys;
	                var audio = new Audio(prefix + notes[index]);
	                audio.play();
	            });
	        }
	    },
	    ready: function ready() {
	        var _this = this;
	
	        document.body.addEventListener('keydown', function (e) {
	            _this.play(e.keyCode);
	        });
	        this.loading = true;
	        load(function (_) {
	            _this.loading = false;
	        });
	    }
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var load = __webpack_require__(1);
	
	var prefix = 'data:audio/mpeg;base64,';
	var base = 0;
	var keys = 12;
	exports.default = {
	    props: {
	        group: {
	            type: Number,
	            default: 0
	        }
	    },
	    data: function data() {
	        return {
	            blacks: [1, 3, 6, 8, 10],
	            whites: [0, 2, 4, 5, 7, 9, 11]
	        };
	    },
	
	    computed: {
	        start: function start() {
	            return this.group * keys;
	        }
	    },
	    methods: {
	        play: function play(index) {
	            load(function (module) {
	                var notes = module.notes;
	                var audio = new Audio(prefix + notes[index + base]);
	                audio.play();
	            });
	        },
	        calcLeft: function calcLeft(index) {
	            var unit = 14.29;
	            var i = this.blacks.indexOf(index);
	            if (i < 2) {
	                return unit * (0.75 + i);
	            }
	            return unit * (1.75 + i);
	        },
	        click: function click(index) {}
	    }
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */,
/* 8 */
/***/ function(module, exports) {

	module.exports = " <div id=app> <div class=control> <input type=checkbox v-model=full id=full><label for=full>完整键盘</label> <span class=loading v-show=loading>正在加载音频文件...</span> </div> <div class=keyboard> <group :group=0 v-show=full></group> <group :group=1 v-show=full></group> <group :group=2></group> <group :group=3></group> <group :group=4></group> <group :group=5 v-show=full></group> <group :group=6 v-show=full></group> </div> </div> ";

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = " <div class=group _v-0da1d26f=\"\"> <button :class=\"{'white': whites.indexOf(n) > -1, 'black': blacks.indexOf(n) > -1}\" v-for=\"n in 12\" :style=\"{ left: calcLeft(n) + '%' }\" data-note={{start+n}} @click=play(start+n) _v-0da1d26f=\"\"><span v-show=\"n === 0\" _v-0da1d26f=\"\">C</span></button> </div> ";

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(5)
	__vue_script__ = __webpack_require__(3)
	__vue_template__ = __webpack_require__(8)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(6)
	__vue_script__ = __webpack_require__(4)
	__vue_template__ = __webpack_require__(9)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.js
 **/